import { Component } from '@angular/core';
import { IonButton, IonContent, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { downloadOutline } from 'ionicons/icons';
import { injectModalDismiss } from '@shared/utils/overlay';

@Component({
  selector: 'app-update-reminder',
  imports: [IonContent, IonButton, IonIcon],
  templateUrl: './update-reminder.component.html',
  styleUrls: ['./update-reminder.component.css'],
})
export class UpdateReminderComponent {
  private dismissModal = injectModalDismiss();
  constructor() {
    addIcons({ downloadOutline });
  }

  update() {
    this.dismissModal(null, 'update');
  }

  skip() {
    this.dismissModal(null, 'skip');
  }
}
